import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Box } from '@mui/material';
import { InfoOutlined, CancelOutlined } from "@mui/icons-material"

// Create the Snackbar Context
const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    type: 'info',
    message: '',
    anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, // Default position
    showIcon: true
  });

  const showSnackbar = (
    message, 
    type = 'info',
    anchorOrigin = null,
    showIcon = true) => {
    setSnackbar({ open: true, type, message, anchorOrigin, showIcon });
  };

  const hideSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const typeStyles = {
    info: {
      backgroundColor: 'var(--primary-color)',
      color: '#000',
      defaultIcon: <InfoOutlined sx={{ marginRight: 1 }} />,
    },
    error: {
      backgroundColor: '#fdeded', 
      color: '#5f2120',
      defaultIcon: <CancelOutlined sx={{ marginRight: 1 }} />,
    },
  };

  const { backgroundColor, color, defaultIcon } = typeStyles[snackbar.type] || {};

  return (
    <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={hideSnackbar}
        anchorOrigin={ snackbar.anchorOrigin || { vertical: 'bottom', horizontal: 'center' }}
        message={snackbar.message}
        sx={{
            backgroundColor,
            color,
            bottom: '64px !important', // Adjust bottom position
            borderRadius: 1,
            width: 'calc(100% - 32px)',
            margin: 'auto',
            justifyContent: 'flex-start', // Center content horizontally
            wordBreak: 'break-all',
        }}
      >
         <Box sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
            {snackbar.showIcon && (
              <Box 
                sx={{
                  'svg': { verticalAlign: 'middle' }
                }}
              >
              { defaultIcon} {/* Render icon only if showIcon is true */}
              </Box>
            )}
            <span>{snackbar.message}</span> {/* Display the message */}
          </Box>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

// Custom Hook to Use Snackbar
export const useSnackbar = () => useContext(SnackbarContext);
